import { IAcceptInvite, IDeclineInvite } from "../types";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { useAcceptInvite } from "./useAcceptInvite";
import { useDeclineInvite } from "./useDeclineInvite";
import { openNotification } from "utils/notification";
import { useQueryClient } from "react-query";
import { Form } from "antd";
import { QUERY_KEY_FOR_TALENT_INVITE } from "./useFetchTalentInvites";

export const useHandleInvite = () => {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const { token } = useGetUserInfo();
  const { mutate: acceptMutate, isLoading: isAccepting } = useAcceptInvite();
  const { mutate: declineMutate, isLoading: isDeclining } = useDeclineInvite();

  const InviteSubmit = (values: any) => {
    const props: IAcceptInvite = {
      token,
      ...values,
    };
    acceptMutate(props, {
      onError: (err: any) => {
        openNotification({
          title: "Error",
          state: "error",
          description: "Error occurred try again",
          duration: 4.5,
        });
      },
      onSuccess: (res: any) => {
        openNotification({
          title: "Success",
          state: "success",
          description: "Successfully",
          duration: 4.5,
        });
        form.resetFields();
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY_FOR_TALENT_INVITE],
        });

        setTimeout(() => {
          window.location.reload();
        }, 500);
      },
    });
  };

  const declineInvite = (values: any, reason?: string) => {
    const props: IDeclineInvite = {
      token,
      ...values,
      decline_reason: reason,
    };
    declineMutate(props, {
      onError: (err: any) => {
        openNotification({
          title: "Error",
          state: "error",
          description: "Error occurred try again",
          duration: 4.5,
        });
      },
      onSuccess: (res: any) => {
        openNotification({
          title: "Success",
          state: "success",
          description: "Decline successful",
          duration: 4.5,
        });
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY_FOR_TALENT_INVITE],
        });

        setTimeout(() => {
          window.location.reload();
        }, 500);
      },
    });
  };

  return {
    isLoading: isAccepting || isDeclining,
    InviteSubmit,
    declineInvite,
    isAccepting,
    isDeclining,
  };
};
